module.exports = __webpack_public_path__ + "img/serverError.409d174f.png";